// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Tag__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tag/Tag.scss
 ** module id = 944
 ** module chunks = 1
 **/